import API from '@/services/api'
import { SET_UPLOAD_LOADING } from './loader'

// Actions
export const ADD_IMAGE = 'addImage'
export const REMOVE_IMAGE = 'removeImage'

const actions = {
	[ADD_IMAGE] (context, data) {
		return new Promise((resolve, reject) => {
			context.dispatch(SET_UPLOAD_LOADING, true);

			API.post('media', data).then((response) => {
				context.dispatch(SET_UPLOAD_LOADING, false);

				resolve(response.data)
			}).catch((response) => {
				context.dispatch(SET_UPLOAD_LOADING, false);

				reject(response.data)
			})
		})
	},
	[REMOVE_IMAGE] (context, data) {
		return new Promise((resolve, reject) => {
			API.delete('media/' + data.id, data).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response.data)
			})
		})
	},
}

export default {
	actions,
}